import moment, { Moment } from "moment";
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import pdfToText from "react-pdftotext";
import mammoth from "mammoth";

import { DateFormat } from "../helper/constants"

export function cn(...inputs: any[]) {
  return twMerge(clsx(inputs));
}

export const  HandleReformatDate = (date: moment.Moment | string) => {
  if (typeof date !== "string" && date.isValid()) {
    return moment(date).format("yyyy-MM-DD");;
  }
};

export const ReformatDate = (date: Date) => {
  return moment(date).format(DateFormat);
};


export const SeparatePortions = (items: any[], portionsPerSlide: number) => {
    const oldItems = [...items];
    var portions: any[][] = [];

    // Loop until slides are empty
    while (oldItems.length > 0) {
        if (oldItems.length >= portionsPerSlide) {
            portions.push(oldItems.splice(0, portionsPerSlide));
        } else {
            portions.push(oldItems);
        break;
        }
    }

    return portions;
}

export const TruncateText = (value : string, limit : number) => {
    if(!value) return;
    return value.length > limit ? value.slice(0,100) + "...": value
}


export const GetExtensionFromMimeType = (mimeType : string) => {
  const mimeToExtensionMap = {
    // Images
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/gif': 'gif',
    'image/webp': 'webp',
    'image/bmp': 'bmp',
    'image/svg+xml': 'svg',
    'image/tiff': 'tiff',
    'image/x-icon': 'ico',

    // Videos
    'video/mp4': 'mp4',
    'video/quicktime': 'mov',
    'video/x-msvideo': 'avi',
    'video/x-matroska': 'mkv',
    'video/webm': 'webm',
    'video/mpeg': 'mpeg',
    'video/3gpp': '3gp',
    'video/3gpp2': '3g2',
  };

  return mimeToExtensionMap[mimeType] || 'jpg'; // 'bin' as default fallback
}

export const BlobToFile = (blob : Blob, fileName : string)  => {
  return new File([blob], fileName, {
    type: blob.type,
    lastModified: Date.now(),
  });
}

export const GetFileExtension = (filename: string) => {
  const dotIndex = filename.lastIndexOf(".");
  return dotIndex !== -1 ? filename.slice(dotIndex + 1).toLowerCase() : "";
}

export const FileToText = async (file: File) => {
  
  if(!file) return  null;

  const ext = GetFileExtension(file.name);

  switch (ext) {
    case "pdf": {
      return await pdfToText(file);
    }
    case "docx": {
      const arrayBuffer = await file.arrayBuffer();
      const { value } = await mammoth.extractRawText({ arrayBuffer: arrayBuffer });
      return value;
    }
    case "txt": {
      return await file.text();
    }
    default:
      return null;
  }
}

export const IsFutureOrToday = (current: Moment) => {
  return current.isSameOrAfter(moment().startOf("day"));
};

export const UnescapeForJson = (text: string) => {
  if (!text) return "";

  return text
    .replace(/\\r\\n/g, "\n")   // turn \r\n sequences back into real newlines
    .replace(/\\"/g, '"')       // unescape quotes
    .replace(/\\\\/g, "\\");    // unescape backslashes
};